import { ComponentProps, CSSProperties } from 'react';
import cn from 'classnames';

import './Skeleton.styles.scss';

export enum SkeletonShape {
    Rect = 'rect',
    Circle = 'circle',
    Text = 'text'
}

type IProps = Omit<ComponentProps<'div'>, 'children'> & {
    shape?: SkeletonShape;
    width?: number;
    height?: number;
    radius?: number;
};

const ROOT_FONT_SIZE = 16;

const toRem = (px?: number) => (px === undefined ? undefined : `${px / ROOT_FONT_SIZE}rem`);

const Skeleton = ({ shape = SkeletonShape.Text, width, height, radius = 4, className, style, ...props }: IProps) => {
    const getStyles = (): CSSProperties => {
        const baseStyles: CSSProperties = {
            width: toRem(width) || '100%',
            height: toRem(height)
        };

        if (shape === SkeletonShape.Circle) {
            return {
                ...baseStyles,
                borderRadius: '50%',
                aspectRatio: '1/1'
            };
        }

        return {
            ...baseStyles,
            borderRadius: toRem(radius)
        };
    };

    return <div className={cn('Skeleton', className)} style={{ ...getStyles(), ...style }} {...props} />;
};

export default Skeleton;
